<template>
    <div class="head">
        <div class="head_box">
            <div class="logo">
                <router-link :to="{name:'index'}"><img src="../assets/img/logo.png"></router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Head"
    }
</script>

<style scoped>
    .head{ height: 59px; margin:0 auto; background: #fff}
    .head_box{ width: 1200px; margin: 0 auto; height: 59px}
    .head .logo{ float: left; height: 59px; overflow: hidden}
</style>


// WEBPACK FOOTER //
// src/components/head.vue